var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionfailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38 18C38 20.9 37.14 23.56 35.66 25.78C33.5 28.98 30.08 31.24 26.1 31.82C25.42 31.94 24.72 32 24 32C23.28 32 22.58 31.94 21.9 31.82C17.92 31.24 14.5 28.98 12.34 25.78C10.86 23.56 10 20.9 10 18C10 10.26 16.26 4 24 4C31.74 4 38 10.26 38 18Z",
    fill: "#C31162"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 36.94L39.2 37.72C38.46 37.9 37.88 38.46 37.72 39.2L37.02 42.14C36.64 43.74 34.6 44.22 33.54 42.96L24 32L14.46 42.98C13.4 44.24 11.36 43.76 10.98 42.16L10.28 39.22C10.1 38.48 9.52001 37.9 8.8 37.74L5.5 36.96C3.98 36.6 3.44 34.7 4.54 33.6L12.34 25.8C14.5 29 17.92 31.26 21.9 31.84C22.58 31.96 23.28 32.02 24 32.02C24.72 32.02 25.42 31.96 26.1 31.84C30.08 31.26 33.5 29 35.66 25.8L43.46 33.6C44.56 34.68 44.02 36.58 42.5 36.94Z",
    fill: "#C31162"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.16 11.96L26.34 14.32C26.5 14.64 26.92 14.96 27.3 15.02L29.44 15.38C30.8 15.6 31.12 16.6 30.14 17.58L28.48 19.24C28.2 19.52 28.04 20.06 28.14 20.46L28.62 22.52C29 24.14 28.14 24.78 26.7 23.92L24.7 22.74C24.34 22.52 23.74 22.52 23.38 22.74L21.38 23.92C19.94 24.76 19.08 24.14 19.46 22.52L19.94 20.46C20.02 20.08 19.88 19.52 19.6 19.24L17.94 17.58C16.96 16.6 17.28 15.62 18.64 15.38L20.78 15.02C21.14 14.96 21.56 14.64 21.72 14.32L22.9 11.96C23.48 10.68 24.52 10.68 25.16 11.96Z",
    fill: "#C31162"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionfailure);
export default __webpack_public_path__ + "static/media/transactionfailure.878dfe94d04514ec8dc23adeeadfec49.svg";
export { ForwardRef as ReactComponent };